import { ROUTES } from '#/config/routes';
import { createTextFilterMeta } from '#/modules/commonComponents/table/columnFilterMeta';
import { createEditLinkColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';

function buildSpecBaseColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createEditLinkColumn({
      getEditPath: (row) => ROUTES.mtrSpecEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.code || '—'} />
      ),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
  ];
}

export function buildSpecSelectColumns({
  filters = {},
  onFilterChange,
  canShowEdit,
}) {
  return [
    ...buildSpecBaseColumns({ filters, onFilterChange, canShowEdit }),
    {
      header: '選項數',
      accessorKey: 'optionCount',
      size: 96,
      enableSorting: false,
    },
  ];
}

export function buildSpecInputColumns({
  filters = {},
  onFilterChange,
  canShowEdit,
}) {
  return buildSpecBaseColumns({ filters, onFilterChange, canShowEdit });
}
